import { render, staticRenderFns } from "./NotificationsButton.vue?vue&type=template&id=05b27df8&"
import script from "./NotificationsButton.vue?vue&type=script&lang=js&"
export * from "./NotificationsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports